
import {BrowserRouter,Routes,Route} from 'react-router-dom'
import Login from "./pages/login";
import Register from './pages/register';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Resellers from './pages/reseller';
import Referrals from './pages/referrals';
import Beneficaries from './pages/beneficaries';
import Commisions from './pages/commissions';
import Settlement from './pages/settlement';
import Monthlyinvoice from './pages/monthlyinvoice';
import Profile from './pages/profile';
import Permissions from './pages/permissions';
import Roles from './pages/roles';
import Users from './pages/users';


function App() {
  return (
    <BrowserRouter>  {/* Wrap the entire app inside BrowserRouter */}
      <div>
        
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Register" element={<Register />} />
          <Route path='/web' element={<Layout/>} />
          <Route path="/dashboard" element={<Layout><Dashboard /></Layout> } />
          <Route path="/resellers" element={<Layout><Resellers /></Layout> } />
          <Route path="/referrals" element={<Layout><Referrals /></Layout> } />
          <Route path="/beneficaries" element={<Layout><Beneficaries /></Layout> } />
          <Route path="/commissions" element={<Layout><Commisions /></Layout> } />
          <Route path="/settlement" element={<Layout><Settlement /></Layout> } />
          <Route path="/monthlyinvoice" element={<Layout><Monthlyinvoice /></Layout> } />
          <Route path="/profile" element={<Layout><Profile /></Layout> } />
          <Route path="/permissions" element={<Layout><Permissions /></Layout> } />
          <Route path="/roles" element={<Layout><Roles /></Layout> } />
          <Route path="/users" element={<Layout><Users /></Layout> } />

        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
